import { apiUrls, befeUrls } from '../../constants/apiUrls';
import { handlePromise } from '../helpers';
import ENV from '../../environments';

export const getPendingInvoiceStatus = async (payload) => {
  const apiPayload = {
    method: 'POST',
    url: ENV.getTeamDeboardUrl() + apiUrls.pendingInvoiceStatus,
    data: payload
  };

  return handlePromise(apiPayload);
};

export const acceptGstPenalty = async (params) => {
  const apiPayload = {
    method: 'POST',
    url: ENV.getTeamDeboardUrl() + apiUrls.acceptGstPenalty,
    params
  };

  return handlePromise(apiPayload);
};

export const acceptFST = (params) => {
  const apiPayload = {
    method: 'POST',
    params,
    url: ENV.getTeamDeboardUrl() + apiUrls.acceptFST
  };

  return handlePromise(apiPayload);
};

export const getFSTBreakUp = async (params) => {
  const apiPayload = {
    method: 'POST',
    params,
    url: ENV.getTeamDeboardUrl() + apiUrls.getFSTBreakUp
  };

  return handlePromise(apiPayload);
};

export const downloadBreakUpFSTDoc = async (resourceId) => {
  const apiPayload = {
    method: 'GET',
    url: ENV.getTeamDeboardUrl() + apiUrls.downloadFSTDoc + resourceId
  };

  return handlePromise(apiPayload);
};

export const getFnfConfig = async (params) => {
  const apiPayload = {
    method: 'GET',
    params,
    url: ENV.getBefeBasePath() + befeUrls.fnfJourney
  };
  return handlePromise(apiPayload);
};

export const uploadDocument = async (data, params) => {
  const apiPayload = {
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
    params,
    url: ENV.getTeamDeboardUrl() + apiUrls.uploadDocument
  };

  return handlePromise(apiPayload);
};

export const deleteDocument = async (fileName) => {
  const apiPayload = {
    method: 'GET',
    url: ENV.getTeamDeboardUrl() + apiUrls.deleteDocument + '/' + fileName
  };

  return handlePromise(apiPayload);
};

export const validateDocuments = async (params) => {
  const apiPayload = {
    method: 'GET',
    params,
    url: ENV.getTeamDeboardUrl() + apiUrls.validateDocuments
  };

  return handlePromise(apiPayload);
};

export const ESignDoc = async (data) => {
  const apiPayload = {
    method: 'POST',
    data,
    url: ENV.getTeamDeboardUrl() + apiUrls.ESignDoc
  };

  return handlePromise(apiPayload);
};

export const fnfInitiateApi = async (params) => {
  const apiPayload = {
    method: 'POST',
    url: ENV.getTeamDeboardUrl() + apiUrls.fnfInitiate,
    data: params
  };
  return handlePromise(apiPayload);
};

export const skipUpdateAccount = async (data) => {
  const apiPayload = {
    method: 'POST',
    url: ENV.getTeamDeboardUrl() + apiUrls.skipUpdateAccount,
    data
  };
  return handlePromise(apiPayload);
};

export const fetchFNFDetail = async (params) => {
  const apiPayload = {
    method: 'GET',
    params,
    url: ENV.getTeamDeboardUrl() + apiUrls.fnfDetails
  };

  return handlePromise(apiPayload);
};

export const addnUpload = async (params, data) => {
  const apiPayload = {
    method: 'POST',
    params,
    url: ENV.getTeamDeboardUrl() + apiUrls.addnUpload,
    data
  };
  return handlePromise(apiPayload);
};

export const downloadContract = async (params) => {
  const apiPayload = {
    method: 'GET',
    params,
    headers: { 'x-source-config-id': 'TEAM' },
    url: ENV.getTeamContractBaseUrl() + apiUrls.downloadContractDocument
  };

  return handlePromise(apiPayload);
};

export const downloadEft = async (params) => {
  const apiPayload = {
    method: 'GET',
    params,
    headers: { 'x-source-config-id': 'TEAM' },
    url: ENV.getTeamDeboardUrl() + apiUrls.downloadEFT
  };

  return handlePromise(apiPayload);
};

export const downloadDeboardEft = async (params) => {
  const apiPayload = {
    method: 'GET',
    params,
    headers: { 'x-source-config-id': 'TEAM' },
    url: ENV.getTeamDeboardUrl() + apiUrls.downloadDeboardEFT
  };

  return handlePromise(apiPayload);
};

export const uploadDeabordEft = async (params, data) => {
  const apiPayload = {
    method: 'POST',
    params,
    data,
    headers: { 'x-source-config-id': 'TEAM' },
    url: ENV.getTeamDeboardUrl() + apiUrls.uploadDeboardEFT
  };

  return handlePromise(apiPayload);
};

export const getErpBankDetails = async (params) => {
  const apiPayload = {
    method: 'GET',
    params,
    url: ENV.getBaseUrl() + apiUrls.erpBankDetails
  };

  return handlePromise(apiPayload);
};

export const uploadApproverDocument = async (data, params) => {
  const apiPayload = {
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
    params,
    url: ENV.getTeamDeboardUrl() + apiUrls.uploadApproverDocument
  };

  return handlePromise(apiPayload);
};